import { createEvent, createStore } from 'effector'

export type ApiCall = {
  url: string
  method: string
  duration: number
  status: number
  timestamp: number
}

export const apiCallCompleted = createEvent<ApiCall>()
export const clearApiMetrics = createEvent()

const MAX_CALLS = 50

export const $apiCalls = createStore<ApiCall[]>([])
  .on(apiCallCompleted, (state, call) => [...state.slice(-(MAX_CALLS - 1)), call])
  .reset(clearApiMetrics)
